"use client"
import { createContext, useContext } from "react"
import { Table } from "@/types"

/* Account ID Layout Context */
type AccountIdContextProps = {
    accountId: string
}
export const AccountIdContext = createContext<AccountIdContextProps>({ accountId: "" })
export const useAccountIdContext = () => useContext(AccountIdContext)
export const AccountIdProvider = ({ children, accountId }: { children: React.ReactNode; accountId: string }) => <AccountIdContext.Provider value={{ accountId }}>{children}</AccountIdContext.Provider>

/* Account Data Layout Context */
type AccountContextProps = {
    account: Table<"accounts">
    isLoading: boolean
    error: any
}
export const AccountContext = createContext<AccountContextProps>({ account: {} as Table<"accounts">, isLoading: false, error: null })
export const useAccountContext = () => useContext(AccountContext)
export const AccountProvider = ({ children, account, isLoading, error }: { children: React.ReactNode; account: Table<"accounts">; isLoading: boolean; error: any }) => <AccountContext.Provider value={{ account, isLoading, error }}>{children}</AccountContext.Provider>
